/* AQQA Studio V5 — close the other product detail panels when opening one. */
(()=>{'use strict';
  function init(root=document){
    const groups=[];
    if(root.matches?.('[data-aqqa-exclusive-accordions]')) groups.push(root);
    groups.push(...root.querySelectorAll('[data-aqqa-exclusive-accordions]'));
    groups.forEach(group=>{
      if(group.dataset.aqqaAccordionBound==='true')return;
      group.dataset.aqqaAccordionBound='true';
      const items=[...group.querySelectorAll('details')];
      items.forEach(item=>item.addEventListener('toggle',()=>{
        if(item.open)items.forEach(other=>{if(other!==item&&other.open)other.open=false;});
      }));
      let found=false;
      items.forEach(item=>{if(item.open){if(found)item.open=false;found=true;}});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
